<template>
	<div id="app" v-if="configLoaded">
		<transition
			type="transition"
			:name="transitionName"
			:mode="transitionMode"
			@before-enter="isTransitioning = true"
			@after-enter="isTransitioning = false"
			>
			<router-view />
		</transition>
		<RestrictOrientation />
		<FullScreen />
		<MuteToggle />
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import transitionSettings from '@/mixins/transition-settings';
import FullScreen from '@/components/base/FullScreen';
import MuteToggle from '@/components/base/MuteToggle';
import RestrictOrientation from '@/components/base/RestrictOrientation';

export default {
	name: 'App',
	components: {
		FullScreen,
		MuteToggle,
		RestrictOrientation,
	},
	mixins: [transitionSettings],
	computed: {
		...mapState({
			configLoaded: (state) => state.global.api.loaded,
		}),
	},
	methods: {
		...mapActions([
			"getAppConfig",
		]),
	},
	async beforeCreate() {
		await this.$store.dispatch("global/api/getAppConfig");
		this.$router.replace(window.location.pathname);
	},
};
</script>

<style lang="scss">
	@import '../static/bootstrap-reboot.min.css';
	@import 'assets/styles/utilities/**/*.scss';

	html, body {
		height: 100%;
		font-family: $body-font;
		font-size: 20px;
		overflow: hidden;
		-ms-text-size-adjust: none;
		-moz-text-size-adjust: none;
		-o-text-size-adjust: none;
		-webkit-text-size-adjust: none;

		@include mobile {
			font-size: 14px;
			background: $background-color-dark;
		}

		@include tablet { background: $background-color-dark; }
	}

	#app { height: 100%; }

	a {
		text-decoration: underline;
		transition: all $ui-transition-duration;
		color: $alt-color;

		&:hover { color: $warning-color; }
	}
</style>



// WEBPACK FOOTER //
// src/App.vue